// extracted by mini-css-extract-plugin
export default {"title":"AnuncioForm_title__KnKqy","label":"AnuncioForm_label__zH-bX","atividadeCard":"AnuncioForm_atividadeCard__LYA54"};